module.exports = new __parcel__URL__("loom.4e5a8d5b.gif").toString();